import { KeyboardEvent, MouseEvent } from 'react';
import { PrimaryCategoryData } from 'types';
import { checkStores, setDataEmTag } from 'utility/utility';

interface Props {
  desktopNavData: PrimaryCategoryData[];
  showSubMenu: boolean;
  currentCategoryIndex: number | null;
  handleMouseClick: (event: MouseEvent<HTMLAnchorElement>, index: number) => void;
  handleKeyDownPrimaryCategory: (event: KeyboardEvent, index: number) => void;
}

const PrimaryCategories = ({
  desktopNavData,
  showSubMenu,
  currentCategoryIndex,
  handleMouseClick,
  handleKeyDownPrimaryCategory,
}: Props) => {
  return (
    <>
      {desktopNavData.map((data, index) => (
        <a
          data-testid="PrimaryCategoriesItem"
          key={data.title}
          className={`desktop-nav-container__nav--list-item hmf-p-xxs${
            index === currentCategoryIndex && showSubMenu ? ' active' : ''
          }${data.title.toLowerCase() === 'clearance' || data?.highlight ? ' clearance' : ''}`}
          href={checkStores(data.link)}
          id={`desktop-nav-l0-${index}`}
          onClick={(event) => handleMouseClick(event, index)}
          onKeyDown={(event) => handleKeyDownPrimaryCategory(event, index)}
          aria-current={index === currentCategoryIndex}
          aria-expanded={index === currentCategoryIndex}
          data-em={setDataEmTag('TopNav', data.title)}>
          <div className="desktop-nav-container__nav--list-item hidden-item hmf-subheader-bold-m">
            {data.title}
          </div>
          {data.title}
        </a>
      ))}
    </>
  );
};

export default PrimaryCategories;
